module.exports = __webpack_public_path__ + "static/img/business.de6102b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/company/business.jpg
// module id = vSP0
// module chunks = 2